// extracted by mini-css-extract-plugin
module.exports = {"emptyListTitle":"EmptyNotesList_emptyListTitle__3dIgB","emptyListSubtitle":"EmptyNotesList_emptyListSubtitle__1JHDw","emptyListWrapper":"EmptyNotesList_emptyListWrapper__373TS"};